import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

import Navbar     from './components/layout/Navbar';
import Footer     from './components/layout/Footer';

import HomePage       from './pages/HomePage';
import ShopPage       from './pages/ShopPage';
import ProductPage    from './pages/ProductPage';
import CartPage       from './pages/CartPage';
import CheckoutPage   from './pages/CheckoutPage';
import OrderPage      from './pages/OrderPage';
import OrdersPage     from './pages/OrdersPage';
import ReturnPage     from './pages/ReturnPage';
import LoginPage      from './pages/LoginPage';
import RegisterPage   from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import ProfilePage    from './pages/ProfilePage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts  from './pages/admin/AdminProducts';
import AdminOrders    from './pages/admin/AdminOrders';
import AdminReturns   from './pages/admin/AdminReturns';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;
  return user && isAdmin ? children : <Navigate to="/" />;
};

function AppRoutes() {
  return (
    <BrowserRouter>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          {/* Public */}
          <Route path="/"           element={<HomePage />} />
          <Route path="/shop"       element={<ShopPage />} />
          <Route path="/shop/:category" element={<ShopPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/cart"       element={<CartPage />} />
          <Route path="/login"      element={<LoginPage />} />
          <Route path="/register"   element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/payment/bkash/callback" element={<PaymentCallbackPage />} />

          {/* Protected */}
          <Route path="/checkout"   element={<PrivateRoute><CheckoutPage /></PrivateRoute>} />
          <Route path="/orders"     element={<PrivateRoute><OrdersPage /></PrivateRoute>} />
          <Route path="/orders/:id" element={<PrivateRoute><OrderPage /></PrivateRoute>} />
          <Route path="/return/:orderId" element={<PrivateRoute><ReturnPage /></PrivateRoute>} />
          <Route path="/profile"    element={<PrivateRoute><ProfilePage /></PrivateRoute>} />

          {/* Admin */}
          <Route path="/admin"           element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/products"  element={<AdminRoute><AdminProducts /></AdminRoute>} />
          <Route path="/admin/orders"    element={<AdminRoute><AdminOrders /></AdminRoute>} />
          <Route path="/admin/returns"   element={<AdminRoute><AdminReturns /></AdminRoute>} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <AppRoutes />
      </CartProvider>
    </AuthProvider>
  );
}
